import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Policy } from "@shared/models/policy";
import { Quotation } from "@shared/models/quotation";
import { IdleUserService } from "@shared/services/idle-user.service";
import { PolicyService } from "@shared/services/policy.service";
import { QuotationService } from "@shared/services/quotation.service";
import { AccordionModule } from "primeng/accordion";
import { ButtonModule } from "primeng/button";
import { ContractComponent } from "./contract/contract.component";
import { QuotationComponent } from "./quotation/quotation.component";

@Component({
  selector: "app-home",
  standalone: true,
  providers: [
    {
      provide: ActivatedRoute,
      useValue: {},
    },
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
  imports: [CommonModule, ButtonModule, AccordionModule, QuotationComponent, ContractComponent, TranslateModule],
})
export class HomeComponent implements OnInit {
  policies: Policy[] = [];
  quotations: Quotation[] = [];
  openAccordionPolicies = false;
  constructor(
    private policyService: PolicyService,
    private quotationService: QuotationService,
    private idleService: IdleUserService
  ) {}

  ngOnInit() {
    this.idleService.setUserIdle();
    this.loadMemberPolicies();
    this.loadMemberQuotations();
  }

  loadMemberPolicies() {
    this.policyService.getPolicies().subscribe(policies => {
      this.policies = policies;
      if (this.policies.length > 0) this.openAccordionPolicies = true;
    });
  }

  loadMemberQuotations() {
    this.quotationService.getQuotations().subscribe(quotations => {
      this.quotations = quotations;
    });
  }
}
